<!--
  NOTA: atualmente existe um bug no interpretador de single file componentes (SFC) do vue, no qual
  as diretivas aplicadas a um componente funcional criado utilizando templates SFC (como este) não
  são repassadas para o código final durante o processo de transpilação, e portanto não funcionam.
  No momento, a única forma para que seja possível utilizar diretivas em componentes funcionais é
  criá-los utilizando funções de renderização e não o formato SFC.

  Fontes:
  https://github.com/vuejs/vue/issues/8261
  https://github.com/vuejs/vue-loader/issues/1433
-->
<template functional>
  <div>
    <label class="obs-checkbox__checkbox-label" :for="props.name">
      <input
        type="checkbox"
        class="obs-checkbox__checkbox"
        :name="props.name"
        :id="props.name"
        :checked="props.checked"
        :disabled="props.disabled"
        @input="listeners.input">
      <span class="obs-checkbox__checkbox-label-text">
        {{ props.label }}
      </span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'input-checkbox',
  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    checked: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
$primary-light: #0F9D8A;

.obs-checkbox__checkbox-label {
  cursor: pointer;
  .obs-checkbox__checkbox {
    appearance: none;
    cursor: pointer;
    width: 24px;
    height: 24px;
    border: 2px solid #707070;
    border-radius: 6px;
    text-align: center;
    font-weight: 900;
    font-size: .875rem;
    line-height: 20px;
    &::before{
      content: '\00a0';
      display: block;
      color: $white;
      width: 20px;
      height: 20px;
    }
    &:disabled {
      border-color: #b8b8b8;
      cursor: default;
      & + .obs-checkbox__checkbox-label-text {
        color: #b8b8b8;
        cursor: default;
      }
    }
    &:checked {
      background-color: $primary-light;
      border-color: $primary-light;
      &::before{
        content: '\2713';
      }
    }
  }
  .obs-checkbox__checkbox-label-text {
    display: inline-block;
    font-size: .875rem;
    padding-left: 1.5rem;
  }
}
</style>
